<template>
  <div class="service-plan">
    <div v-if="$route.query.key == 3" class="serach-around">
      <div class="serach-around-select">
        <van-field
          v-model="searchCriteria.repairStatus"
          :placeholder="this.$t('maintenanceState')"
          class="van-cell-state"
          clickable
          readonly
          @click="showPicker = true"
        />
        <img alt="" class="cell-state-img" src="@/assets/images/icon_down@2x.png">
      </div>
      <van-popup v-model="showPicker" position="bottom" round>
        <van-picker
          :columns="selevtList"
          show-toolbar
          @cancel="showPicker = false"
          @confirm="onConfirm"
        />
      </van-popup>
      <van-field ref="keyword" v-model="searchCriteria.deviceCode" class="number-input" placeholder="请输入出厂编号" @keyup.enter="handleSearch()" />
      <img alt="" class="around-select-img" src="@/assets/images/icon_list@2x.png" @click="showTime = true">
      <van-popup v-model="showTime" position="bottom" round>
        <van-picker
          :columns="columns"
          :title="this.$t('chooseYear')"
          show-toolbar
          @cancel="showTime = false"
          @confirm="onConfirmTime"
        />
      </van-popup>
    </div>
    <div v-if="infolist !== ''" class="body-around-if">
      <div v-for="(item,index) of infolist" :key="index" class="body-around">
        <dr-maintenance :info-list="aroundlist[index]">
          <div class="opera">
            <ul class="base-info">
              <li class="info-item">
                <div class="info_label">
                  <split-label :label="$t('maintenanceState')" class-name="label" />
                </div>
                <div class="info_value complete-btn">
                  <span v-if="buttonStauts === 2" class="btn-color">{{ item.repairStatus }}</span>
                  <span v-else :style=" { color : buttonStauts === 4 || buttonStauts === 3 ? '#005BAC' : '#009966' } ">{{
                    item.repairStatus
                  }}</span>
                </div>
              </li>
            </ul>
            <div :style=" { top: buttonStauts === 2 ? '10px' : '25px' } " class="detail-btn-wrapper">
              <button class="detail-btn detail-btn-detail" @click="handleGoDetailClick(infolist[index].id)">
                {{ $t('ViewDetailed') }}
              </button>
              <button v-if="item.repairStatus === '已完成(待评价)'&&buttonStauts === 4" class="detail-btn" @click="handleGoEvaluateClick(item.id,'wait')"> 评价 </button>
              <button v-if="item.repairStatus === '已提交'&&buttonStauts === 2" class="detail-btn" @click="handleCancelClick(item.id)">
                取消
              </button>
              <button v-if="item.repairStatus === '已评价'" class="detail-btn" @click="handleGoEvaluateClick(item.id,'end')">
                查看评价
              </button>
            </div>
          </div>
        </dr-maintenance>
      </div>
    </div>
    <div v-if="infolist === [] || infolist.length === 0 || infolist === null" class="null-state">
      <img alt="" src="@/assets/images/img_blank@2x.png">
      <p>暂无内容</p>
    </div>
  </div>
</template>

<script>
import DrMaintenance from '@/components/Maintenance'
import { RECORD_STATUS, REPAIR_STATUS, REPAIR_STATUS_reverse } from '@/api/constants'
import { Dialog } from 'vant'

export default {
  name: 'ServiceEvaluate',
  components: { DrMaintenance },
  data() {
    return {
      searchCriteria: {}, // 筛选内容
      Year: '', // 选择年份
      numberInput: '', // 搜索输入内容
      columns: [], // 年份
      selevtList: [], // 下拉列表内容
      timeInfo: '', // 筛选时间
      currentDate: new Date(), // 选择的时间
      showPicker: false, // 时间选择器
      showTime: false, // 时间选择
      selectInfo: '', // 筛选内容
      aroundlist: [], // 信息列表
      infolist: [] // 数据列表
    }
  },
  computed: {
    buttonStauts() {
      return Number(this.$route.query.key)
    },
    changeList() {
      if (this.buttonStauts === 4) {
        return ['WAITING_COMMENT']
      }
      if (this.buttonStauts === 2) {
        return ['TRANSMITTED', 'ALREADY_SUBMIT', 'ALREADY_ALLOT', 'ALREADY_DISPOSE', 'ACCEPTED', 'TRANSMITTED_ERROR']
      }
      return []
    }
  },
  mounted() {
    this.handleGetFiftyYears()
    this.repairInfo()
    this.selevtList = RECORD_STATUS // 下拉列表内容
  },
  methods: {
    /*
      取消报修
    */
    handleCancelClick(id) {
      Dialog.confirm({
        title: '提示',
        message: '该条报修将被取消!'
      })
        .then(() => {
          this.$api('REPAIR_EDIT_CANCEL_H5', {
            UserRepairId: id
          }, true).then((res) => {
            if (res.code === 200) {
              this.repairInfo()
            } else {
              this.$toast(res.msg)
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    /*
      软键盘出发搜索
    */
    handleSearch() {
      this.searchCriteria.repairStatus = REPAIR_STATUS_reverse[this.searchCriteria.repairStatus]
      // 需要搜索的内容
      this.repairInfo()
    },
    /*
      计算向前50年
    */
    handleGetFiftyYears() {
      const Time = new Date()
      this.Year = Time.getFullYear()
      const timeList = [...new Array(50).keys()]// 创建一个0-50的数组
      timeList.forEach(item => {
        return this.columns.push(this.Year - item)
      })
    },
    /*
      时间选择器（年份）
     */
    onConfirm(value) {
      this.searchCriteria.repairStatus = REPAIR_STATUS_reverse[value]
      this.repairInfo('type')
      this.showPicker = false
    },
    onConfirmTime(val) {
      this.searchCriteria.repairStatus = REPAIR_STATUS_reverse[this.searchCriteria.repairStatus]
      this.searchCriteria.inputDate = val + ''
      this.repairInfo()
      this.showTime = false
    },
    /*
      获取列表
     */
    repairInfo(type) {
      this.searchCriteria.repairStatusIn = this.changeList
      const list = Object.keys(this.searchCriteria)
      list.forEach((item) => {
        if (this.searchCriteria[item] === '') {
          delete this.searchCriteria[item]
        }
      })
      this.$api('REPAIR_SEARCH_H5', this.searchCriteria
        , true).then((res) => {
        this.infolist = res.result.content
        this.infolist.forEach((item, index) => {
          item.repairStatus = REPAIR_STATUS[item.repairStatus]
          this.aroundlist[index] = [
            { title: '出厂编号', content: item.deviceCode },
            { title: '型  号', content: item.model },
            { title: '报修时间', content: item.inputDate }
          ]
        })
        this.searchCriteria.repairStatus = REPAIR_STATUS[this.searchCriteria.repairStatus]
      }).catch(() => {
        this.searchCriteria.repairStatus = REPAIR_STATUS[this.searchCriteria.repairStatus]
      })
    },
    handleGoDetailClick(key) {
      this.$router.push({ path: '/planParticular', query: { key }})
    },
    /*
      已完成待评价
     */
    handleGoEvaluateClick(id, stuats) {
      this.$router.push({ path: '/checkEvaluate', query: { id }})
    }
  }
}
</script>

<style lang="scss" scoped>
.repairs-content-voice-title{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 10px;
  .content-voice-title{
    width: 50px;
  }
  .content-voice-del{
    color: #005BAC;
    text-decoration:underline;
  }
}
.des
  .info_label {
    font-weight: 700;
  }

  ::v-deep .van-cell {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding: 0 0 0 9.5px;
    overflow: hidden;
    color: #323233;
    font-size: 0.37333rem;
    line-height: 0.64rem;
    background-color: #fff;
  }

  .info_value {
    font-weight: 700;

    .btn-color {
      color: #009966;
    }
  }

  ::v-deep .dr__maintenance .base-info {
    padding: 27px 16px;

    .info-item {
      display: flex;
    }
  }

  .service-plan {
    padding: 13.5px 15px;
    .null-state {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-top: 140px;
      img {
        width: 190px;
        height: 140px;
      }
      p {
        color: #999999;
        font-size: 15px;
      }
    }
    .null-state-img {
      width: 380px;
      height: 380px;
    }
    .serach-around {
      display: flex;
      justify-content: space-around;
      background-color: #fff;
      height: 40px;
      margin-bottom: 10px;
      padding: 5px 15px;
      align-items: center;

      .number-input {
        border-radius: 5px;
        width: 170px;
        padding-left: 8.5px;
        border: 0.5px #F2F2F2 solid;
        font-size: 12px;
      }

      .around-select-img {
        width: 19px;
        height: 19px;
        margin-left: 9px;
      }

      .van-cell-state {
        height: 25px;
        border: none;
        font-size: 12px;
        width: 125px;
        padding: 0;
      }

      .serach-around-select {
        display: flex;
        align-items: center;
        width: 120px;
        margin-right: 10px;
        border: solid 0.5px #F2F2F2;
        border-radius: 5px;
        padding: 0 5px;

        .cell-state-img {
          width: 10px;
          height: 10px;
        }

        ::v-deep .van-field__control:read-only {
          padding-left: 3.5px;
          font-size: 12px;
        }
      }

      .serach-around-btn {
        height: 30px;
        width: 60px;
        border: none;
        font-size: 15px;
        margin-left: 15px;
      }
    }

    .body-around {
      background-color: #fff;
      margin-bottom: 13.5px;
      border-radius: 5px;
    }

    .opera {
      position: relative;

      .complete-btn {
        color: rgba(0, 91, 172, 1);
      }

      .detail-btn-wrapper {
        top: 0 !important;
        left: 250px;
        height: 100%;
        display: flex;
        flex-direction: row-reverse;

        .detail-btn {
          width: 80px;
          height: 30px;
          margin-right: 11px;
          margin-bottom: 17px;
          border: none;
          outline: none;
          padding: 9px 12px;
          background: #005BAC;
          border-radius: 15px;
          font-size: 13px;
          font-family: PingFang SC Medium, PingFang SC Medium-Medium;
          font-weight: 500;
          color: #ffffff;
          line-height: 13.5px;
        }

        .detail-btn-detail {
          border: #009966 1px solid;
          color: #009966;
          background-color: #ffffff;
        }
      }
    }
  }
</style>
